// extracted by mini-css-extract-plugin
export var button = "_fa-4";
export var hasDarkBackground = "_fa-7";
export var hasLightBackground = "_fa-6";
export var iconWrapper = "_fa-0";
export var large = "_fa-2";
export var medium = "_fa-1";
export var small = "_fa-5";
export var xsmall = "_fa-3";